export enum AnalyticVisualThemeEnum {
  DEFAULT = 'default',
  CLASSIC = 'classic',
  CONTRASTED = 'contrasted',
  PASTEL = 'pastel',
}
